import React, { useEffect, useRef, useState } from "react";
import { getManualLockPriority, saveManualLockPriority, autoLockTeacherWeek, clearTeacherLocksWeek } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// "Xếp tay theo thứ tự ưu tiên" — danh sách GV có PCCM trong tuần theo thứ tự
// ưu tiên (lưu database, dùng chung mọi tuần). Bấm "Xếp tay" -> lần lượt từng GV
// (từ trên xuống, bỏ qua GV đánh dấu "Bỏ qua") gọi API tự xếp tay (CP-SAT);
// GV xếp trước chiếm ô trước, GV sau xếp vào các ô còn lại.
const HappySchoolManualLockPriority = ({ weekId }) => {
  const schoolId = getActiveSchoolId();
  const [list, setList] = useState(null);
  const [saved, setSaved] = useState(true);
  const [err, setErr] = useState("");
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState({}); // id -> { state: "run"|"ok"|"err", text }
  const [reload, setReload] = useState(0);
  // Chỉ xếp các lớp-môn KHỐI 12 từ 4 tiết/tuần trở lên (môn Thi tốt nghiệp 12); bỏ khối 10, 11.
  const [chi4, setChi4] = useState(false);
  const stopRef = useRef(false);

  useEffect(() => {
    if (!schoolId || !weekId) return;
    setErr("");
    getManualLockPriority(schoolId, weekId).then((d) => { setList(d.teachers || []); setSaved(true); }).catch((e) => setErr(e.message));
  }, [schoolId, weekId, reload]);

  if (!weekId) return <p style={{ color: "#6b7280" }}>Chọn tuần trước.</p>;
  if (err && !list) return <p style={{ color: "#dc2626" }}>{err}</p>;
  if (!list) return <p>Đang tải...</p>;

  const move = (i, j) => {
    if (j < 0 || j >= list.length) return;
    const next = list.slice();
    const [x] = next.splice(i, 1);
    next.splice(j, 0, x);
    setList(next);
    setSaved(false);
  };
  // Tích = chọn GV để xếp (lưu database: GV KHÔNG tích = skip).
  const toggleSkip = (i) => { const next = list.slice(); next[i] = { ...next[i], skip: !next[i].skip }; setList(next); setSaved(false); };
  const chonTatCa = (on) => { setList(list.map((t) => ({ ...t, skip: !on }))); setSaved(false); };
  const coViec = (t) => (chi4 ? t.soTiet4 > 0 : t.soTiet > 0);
  const luuThuTu = async () => {
    await saveManualLockPriority(schoolId, list.map((t) => t.id), list.filter((t) => t.skip).map((t) => t.id));
    setSaved(true);
  };
  const onSave = async () => { try { await luuThuTu(); } catch (e) { window.alert(e.message || "Không lưu được."); } };

  const xepTay = async () => {
    const chay = list.filter((t) => !t.skip && coViec(t));
    if (!chay.length) return;
    if (!window.confirm(`Xếp tay lần lượt ${chay.length} giáo viên đã chọn theo thứ tự ưu tiên${chi4 ? ", CHỈ các lớp-môn khối 12 từ 4 tiết/tuần trở lên (Thi tốt nghiệp 12, bỏ khối 10, 11)" : ""}?\nTiết xếp tay CŨ của từng GV ở ${chi4 ? "các lớp-môn đó" : "các lớp-môn GV đó dạy"} sẽ được xếp lại.`)) return;
    setRunning(true);
    stopRef.current = false;
    setProgress({});
    try { if (!saved) await luuThuTu(); } catch (e) { /* vẫn chạy */ }
    for (const t of chay) {
      if (stopRef.current) break;
      setProgress((p) => ({ ...p, [t.id]: { state: "run", text: "Đang xếp..." } }));
      try {
        const r = await autoLockTeacherWeek(schoolId, weekId, { teacherId: t.id, replace: true, timeLimit: 10, ...(chi4 ? { minNeed: 4, onlyKhoi12: true } : {}) });
        const created = (r.created || []).length;
        const thieu = (r.shortages || []).reduce((a, x) => a + Math.max(0, (Number(x.need) || 0) - (Number(x.placed) || 0)), 0);
        // Chi tiết thiếu theo từng lớp-môn: "12A7 Toán: 3/4 (thiếu 1)"
        const chiTiet = (r.shortages || []).filter((x) => (Number(x.need) || 0) > (Number(x.placed) || 0))
          .map((x) => `${x.className || x.classId}${x.subjectName ? ` ${x.subjectName}` : ""}: ${Number(x.placed) || 0}/${Number(x.need) || 0} (thiếu ${(Number(x.need) || 0) - (Number(x.placed) || 0)})`);
        setProgress((p) => ({ ...p, [t.id]: { state: thieu > 0 ? "warn" : "ok", text: `Xếp ${created} tiết${thieu > 0 ? ` — thiếu ${thieu}` : ""}`, chiTiet } }));
      } catch (e) {
        setProgress((p) => ({ ...p, [t.id]: { state: "err", text: e.message || "Lỗi" } }));
      }
    }
    setRunning(false);
    setReload((k) => k + 1);
  };

  const xoaLich = async () => {
    const chon = list.filter((t) => !t.skip);
    const coLich = chon.filter((t) => t.daXep > 0);
    if (!coLich.length) { window.alert("Các giáo viên đã chọn chưa có tiết xếp tay nào."); return; }
    if (!window.confirm(`XOÁ lịch xếp tay tuần này của ${coLich.length} giáo viên đã chọn${chi4 ? " (chỉ các lớp-môn khối 12 từ 4 tiết/tuần trở lên)" : ""}?\n${coLich.map((t) => `- ${t.name} (${t.daXep} tiết)`).join("\n")}`)) return;
    setRunning(true);
    try {
      const r = await clearTeacherLocksWeek(schoolId, weekId, coLich.map((t) => t.id), chi4 ? 4 : 0, chi4);
      const by = r.byTeacher || {};
      setProgress(Object.fromEntries(coLich.map((t) => [t.id, { state: "ok", text: `Đã xoá ${by[t.id] || 0} tiết` }])));
    } catch (e) { window.alert(e.message || "Không xoá được."); }
    setRunning(false);
    setReload((k) => k + 1);
  };

  const mau = { run: "#2563eb", ok: "#047857", warn: "#b45309", err: "#dc2626" };
  const soChay = list.filter((t) => !t.skip && coViec(t)).length;
  const tatCa = list.length > 0 && list.every((t) => !t.skip);
  return (
    <div>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <p style={{ margin: 0, color: "#6b7280", fontSize: 13, flex: 1, minWidth: 260 }}>
          Thứ tự ưu tiên xếp tay (dùng chung mọi tuần): GV ở trên được xếp trước và chiếm ô trước. Dùng ▲▼ để đổi thứ tự, tích ô "Xếp" để chọn GV cần xếp. Bấm "Xếp tay" để xếp lần lượt các GV đã chọn từ trên xuống.
        </p>
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: chi4 ? "#7c3aed" : "#374151", cursor: running ? "default" : "pointer", border: "1px solid " + (chi4 ? "#7c3aed" : "#d1d5db"), borderRadius: 6, padding: "5px 10px", background: chi4 ? "#f5f3ff" : "#fff" }}>
          <input type="checkbox" checked={chi4} disabled={running} onChange={(e) => setChi4(e.target.checked)} />
          Chỉ xếp lớp 12, môn từ 4 tiết/tuần trở lên (Thi tốt nghiệp 12)
        </label>
        {!saved && <button type="button" onClick={onSave} disabled={running} style={btn}>💾 Lưu thứ tự</button>}
        {running
          ? <button type="button" onClick={() => { stopRef.current = true; }} style={{ ...btn, background: "#dc2626", borderColor: "#dc2626", color: "#fff" }}>⏹ Dừng sau GV đang xếp</button>
          : <button type="button" onClick={xoaLich} disabled={!list.some((t) => !t.skip && t.daXep > 0)} style={{ ...btn, color: "#dc2626", borderColor: "#fca5a5" }}>🗑 Xoá lịch GV đã chọn</button>}
        {!running && <button type="button" onClick={xepTay} disabled={!soChay} style={{ ...btn, background: "#7c3aed", borderColor: "#7c3aed", color: "#fff" }}>🔧 Xếp tay ({soChay} GV)</button>}
      </div>
      <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
        <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
          <thead><tr><th style={th}><label title="Chọn / bỏ chọn tất cả" style={{ cursor: "pointer" }}><input type="checkbox" checked={tatCa} disabled={running} onChange={(e) => chonTatCa(e.target.checked)} /> Xếp</label></th>
            {["Ưu tiên", "", "Giáo viên", "Bộ môn", "Loại", chi4 ? "Lớp học ≥ 4 tiết/tuần" : "Lớp dạy trong tuần", chi4 ? "Tiết (≥4)" : "Tiết/tuần", "Đã xếp tay", "Kết quả"].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {list.map((t, i) => {
              const pg = progress[t.id];
              return (
                <tr key={t.id} style={{ opacity: t.skip || !coViec(t) ? 0.45 : 1, background: pg && pg.state === "run" ? "#eff6ff" : undefined }}>
                  <td style={td}><input type="checkbox" checked={!t.skip} disabled={running} onChange={() => toggleSkip(i)} /></td>
                  <td style={{ ...td, fontWeight: 700 }}>{i + 1}</td>
                  <td style={{ ...td, whiteSpace: "nowrap" }}>
                    <button type="button" disabled={running || i === 0} onClick={() => move(i, i - 1)} style={arrow}>▲</button>
                    <button type="button" disabled={running || i === list.length - 1} onClick={() => move(i, i + 1)} style={arrow}>▼</button>
                  </td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{t.name}</td>
                  <td style={{ ...td, textAlign: "left", fontSize: 12, color: "#1f2937" }}>{(chi4 ? t.mons4 || [] : t.mons || []).join(", ") || "—"}</td>
                  <td style={td}>{t.employmentType || ""}</td>
                  <td style={{ ...td, textAlign: "left", fontSize: 12, color: "#4b5563" }}>{(chi4 ? t.lops4 || [] : t.lops).join(", ") || "—"}</td>
                  <td style={td}>{chi4 ? t.soTiet4 || 0 : t.soTiet}</td>
                  <td style={td}>{t.daXep}</td>
                  <td style={{ ...td, color: pg ? mau[pg.state] : "#9ca3af", fontWeight: pg ? 600 : 400, textAlign: "left" }}>
                    <div style={{ whiteSpace: "nowrap" }}>{pg ? pg.text : ""}</div>
                    {pg && pg.chiTiet && pg.chiTiet.length > 0 && (
                      <div style={{ fontSize: 12, fontWeight: 400, color: "#92400e", marginTop: 2 }}>{pg.chiTiet.map((c, k) => <div key={k}>• {c}</div>)}</div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const btn = { padding: "6px 14px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", cursor: "pointer", fontWeight: 600, fontSize: 13 };
const arrow = { border: "1px solid #d1d5db", background: "#fff", borderRadius: 4, cursor: "pointer", fontSize: 10, padding: "1px 5px", marginRight: 2 };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "5px 8px", textAlign: "center" };

export default HappySchoolManualLockPriority;
